<template>
    <div id="navbar" class="bg-golden">
        <div id="bg-green-curve" class="bg-green m-auto">
            <div id="nv_wrapper">
                <div>
                    <img class="nv-back" v-if="isBack" src="@/assets/image/Navbar/img_icon_navbar.png" alt="" @click="clickBack()" />
                </div>
                <div>
                    <img id="nv_logo_cp" src="@/assets/logo/cpf-logo.png"/>
                </div>
                <div @click="goShoppingCartProduct()">
                    <img class="cart img-fluid" v-if="isShowCart" src="../../../assets/icon/newversion/cart.svg" />
                </div>
            </div>
        </div>
            <modal-master :controller="modalController" :theme="userType"></modal-master>
    </div>
        <!-- <cookie-consent-bar></cookie-consent-bar> -->
</template>
<script>
import Vue from 'vue';
// import { CookieConsentModalController } from "@/components/Modal/Controller/CookieConsentModal.js";
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { CookieModalController } from "@/components/Modal/Controller/CookieModalController.js";
import { CookieConsentModalController } from "@/components/Modal/Controller/CookieConsentModalController.js";
//service
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
import { AccessKeyModel } from '@/core/Account/model/AccessKeyModel.js';
import AccountMixin from "@/mixin/AccountMixin.js";
import PDPAMixin from '@/mixin/PDPAMixin.js'
//service
import PDPAService from "@/core/PDPA/service/BzbsPDPA.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
export default {
    name: 'nav-bar-logo',
    props: {
        userType: String,
        isBack: Boolean,
        isShowCart: Boolean,
        namePage: String,
    },
    mixins: [
        AccountMixin,
        PDPAMixin,
    ],
    components: {
        // // CookieConsentBar
        ModalMaster,
    },
    data: function(){
        return{
            config: Vue.bzbsConfig,

            currentVersion: null,
            userConsent: null,
            //modal
            modalController: new ModalController(),
            cookieConsentModal: new CookieConsentModalController(),
            cookieModal: new CookieModalController(),

            trackingService: new TrackingService(this),
        }
    },
    created: function() {
        this.checkConsentCookie()

        this.modalController.setCookieConsentModal(this.cookieConsentModal)
        this.modalController.setCookieModal(this.cookieModal)
    },
    methods: {
        //Event
        clickBack: function () {
            this.$emit('clickBack');
        },

        goShoppingCartProduct: async function() {
            console.log('goShoppingCartProduct', this.namePage);
            this.trackingService.event(this.namePage, 'click_shopping_cart', null, null)
            let token = this.getToken();
            let accessKey = await this.getShoppingCartAccessKey(token)

            if (accessKey == null) {
                return
            }

            let appName = this.config.appname;
            let url = this.config.bzbNewShoppingCartUrl + `/landing/${appName}?access_key=${accessKey}&appname_config=${appName}`
            window.location.href = url
        },

        getShoppingCartAccessKey: function(token) {
            return new Promise((resolve) => {
                let currentUrl = window.location.href
                let payload = {
                    returnUrl: currentUrl,
                    successUrl: currentUrl,
                    errorUrl: currentUrl,
                    appId: this.config.client_id,
                    appName: this.config.appname,
                    routeMode: 'push',
                }
                let jsonPayload = JSON.stringify(payload)
                BzbsAuth.apiCreateAccessKey(token, jsonPayload)
                    .then(res => {
                        let accessKey = new AccessKeyModel()
                        accessKey.setDataFromApi(res.data.data)
                        resolve(accessKey.accessKey);
                    }).catch(err => {
                        console.log(err);
                        resolve(null);
                    });
            })
        },
        // cookie method
        checkConsentCookie: async function  () {
            const token = this.getToken();
            const currentVersion = await this.getCurrentVersion();
            const userConsent = await this.getUserConsent(token);
            
            if (currentVersion && userConsent) {
                this.currentVersion = currentVersion.data.cookie.current_version;
                this.userConsent = userConsent;

                if (this.currentVersion != userConsent.NecessaryCookies ||
                    this.currentVersion != userConsent.FunctionalCookies) {
                    this.showCookieModals();
                }
            }
        },
        getCurrentVersion: function () {
            return new Promise((resolve) => {
                PDPAService.apiGetPDPAVersion().then((data) => {
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error);
                    resolve(null)
                });
            })
        },
        getUserConsent: function(token) {
            return new Promise((resolve) => {
                PDPAService.apiGetUserPDPA(token).then((res) => {
                    resolve(res.data);
                }).catch((error) => {
                    this.errorApi(error);
                    resolve(null);
                });
            })
        },
        showCookieModals: function (){
            this.modalController.cookieModal.show();
            this.modalController.cookieModal.onClickMoreDetail(() => {
                this.modalController.cookieConsentModal.show();
            });

            const saveCookie = async () => {
                const success = await this.apiSaveCookie(this.currentVersion);
                if (success) {
                    this.modalController.cookieModal.hide();
                }
            };

            this.modalController.cookieModal.onClickOk(saveCookie);
            this.modalController.cookieConsentModal.onClickOk(saveCookie);
            this.modalController.cookieConsentModal.onClickCancel(() => {
                this.modalController.cookieModal.show();
            });
        },
        apiSaveCookie: function(version){
            return new Promise((resolve) =>{
                let token = this.getToken();
                //Save Consent
                PDPAService.apiSaveCookie(token, version).then((res) => {
                    console.log(res.data);
                    resolve(res.data);
                }).catch((error) => {
                    this.errorApi(error);
                    resolve(null);
                });
            })
        },
    }
}
</script>
<style lang="scss" scoped>
@import "./NavBarLogo.scss";
</style>
